import { FunctionComponent, useState } from "react";

import { useParams } from "react-router-dom";

import { ReactComponent as Linkedin } from "@assets/icons/linkedin.svg";
import { ReactComponent as Email } from "@assets/icons/email.svg";

import { SvgIcon } from "@/components/Icon/SvgIcon";

import { Button } from "@/components/Button/Button";

import { useIsFeatureActive } from "@/utils/useIsFeatureActive";

import { InviteUserModal } from "./components/InviteUserModal";
import { UsersTable } from "./components/UsersTable";

import { useSlotsAvailableQuery } from "../../redux/unipile/unipile.api";
import { EditEmailModal } from "./components/EditEmailModal";
import { FeaturesCodes } from "./enum/codes";

export const Users: FunctionComponent = () => {
	const { id } = useParams();

	const { data: slotData } = useSlotsAvailableQuery(id ? +id : undefined);

	const isSequencerActive = useIsFeatureActive(FeaturesCodes.SEQUENCER);

	const [isInviteModalOpen, setIsInviteModalOpen] = useState<boolean>(false);
	const [isEditEmailModalOpen, setIsEditEmailModalOpen] = useState<boolean>(false);

	return (
		<div className="sm:block flex flex-col items-start justify-between">
			<div className="flex flex-row items-center gap-4">
				<div className="mb-4 border border-border-light rounded-xl gap-4 p-4 w-[400px] flex flex-col justify-between">
					<div className="flex flex-row items-center gap-1">
						<SvgIcon className="w-[20px] h-[20px]" svgIcon={Linkedin} />

						<div className="text-sm font-normal">LinkedIn Sending Users</div>
					</div>

					<div className="flex flex-col items-start gap-1">
						<div className="text-smd font-normal text-text">{slotData?.slotAmount} Seats</div>
						<div className="text-sm font-normal text-text-meta">
							{slotData?.slotsAvailable} / {slotData?.slotAmount} seats used
						</div>
					</div>
				</div>
				{isSequencerActive && (
					<div className="mb-4 border border-border-light rounded-xl gap-4 p-4 w-[400px] flex flex-col justify-between">
						<div className="flex flex-row items-center gap-1">
							<SvgIcon className="w-[20px] h-[20px]" svgIcon={Email} />

							<div className="text-sm font-normal">Additional Email Addresses</div>
						</div>

						<div className="flex flex-row items-end justify-between gap-1">
							<div className="flex flex-col items-start gap-1">
								<div className="text-smd font-normal text-text">
									{slotData?.emailsAmount} Emails
								</div>
								<div className="text-sm font-normal text-text-meta">
									{slotData?.emailsUsed} / {slotData?.emailsAmount} emails used
								</div>
							</div>
							{slotData?.hasStripeSubscription ? (
								<div className="text-sm font-normal text-text-meta w-fit">
									<Button
										title="Edit number of Email accounts"
										onClick={() => setIsEditEmailModalOpen(true)}
									/>
								</div>
							) : (
								""
							)}
						</div>
					</div>
				)}
			</div>

			<UsersTable />

			{isInviteModalOpen && (
				<InviteUserModal
					isOpen={isInviteModalOpen}
					isSequencerActive={isSequencerActive}
					setIsOpen={setIsInviteModalOpen}
					slotData={slotData}
				/>
			)}
			{isSequencerActive && isEditEmailModalOpen && (
				<EditEmailModal
					baseAmount={slotData?.emailBaseAmount ?? 0}
					bonusAmount={slotData?.emailsBonusAmount ?? 0}
					companyId={id ? +id : undefined}
					isOpen={isEditEmailModalOpen}
					paidAmount={slotData?.emailsPaidAmount ?? 0}
					pendingAmount={slotData?.emailsPendingAmount}
					pendingEffectiveAt={slotData?.emailsPendingEffectiveAt}
					setIsOpen={setIsEditEmailModalOpen}
				/>
			)}
		</div>
	);
};
